import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginComponent from "../Component/Login/LoginComp/Login";
import ForgotComp from "../Component/Login/Forgotpw/Forgot";
import ConfirmAccComp from "../Component/Login/ConfirmAccount/Confirmacc";
import SetpwComponent from "../Component/Login/Setnewpw/Setpw";
import CodeverifyComp from "../Component/Login/Codeverified/Codeverify";
import PasswordsuccessComp from "../Component/Login/Passwordsuccess/Pwsuccess";
import SignuponeComp from "../Component/SignupFlow/Signupone/Signupone";
import SignuptwoComp from "../Component/SignupFlow/Signuptwo/Signuptwo";
import CreatecommunityComp from "../Component/CreateUser/CreateUser";
import CommunityComp from "../Component/Admin/Community/Community";
import SuperAdmin from "../Component/SuperAdmin/SuperAdmin";
import Admin from "../Component/Admin/Admin";
import DashboardpageComp from "../Component/Dashboard/Dashboard";
import InProgress from "../Pages/InProgress/InProgress";
import SuperadminprofileComp from "../Component/SuperAdmin/SuperAdminProfile/Superadminprofile";
import AdminprofileComp from "../Component/Admin/Admin Profile/Adminprofile";
import ChangePassword from "../Component/changePassword/changepass";
import UpdateProfile from "../Component/UpdateProfile/updateProfile";
import EmailVerificationComp from "../Component/SignupFlow/Email-verification/EmailVerify";
import EmailVerifiedComp from "../Component/SignupFlow/EmailVerified/EmailVerified";
import SignupSuccess from "../Component/SignupFlow/SignupSuccessful/Signupsuccess";
import LayoutComp from "../Layout/Layout";
import Chatboat from "../Component/Chatbot/Chatbot";
import PasswordChange from "../Component/Admin/PasswordChange/passwordChange";
import ViewAdmin  from "../Component/Admin/Community/view-admin"
import UpdateProvider from "../Component/UpdateUser/update-user"
import UpdateAdmin from "../Component/Admin/Admin Profile/update-admin";
const AppRoutes = () => {
  return (
    <BrowserRouter>
                                 {/* public */}
      <Routes>
        <Route path="/dashboard" element={<LayoutComp />} />
        <Route path="/forgot-password" element={<ForgotComp />} />
        <Route path="/confirm-account-otp" element={<ConfirmAccComp />} />
        <Route path="/signupone" element={<SignuponeComp />} />
        <Route path="/signuptwo" element={<SignuptwoComp />} />
        <Route path="/email-verification" element={<EmailVerificationComp />} />
        <Route path="/email-verified" element={<EmailVerifiedComp />} />
        <Route path="/sign-up-success" element={<SignupSuccess />} />
        <Route path="/set-up-new-password" element={<SetpwComponent />} />
        <Route path="/code-verify" element={<CodeverifyComp />} />
        <Route path="/password-success" element={<PasswordsuccessComp />} />
        <Route path="/" element={<LoginComponent />} />
        <Route path="/Admin-community" element={<CommunityComp />} />
        {/* <Route path="/user-listing" element={<CommunityComp />} /> */}
        <Route path="/inprogress" element={<InProgress />} />
        <Route path="/change-password" element={<ChangePassword />} />
        {/* <Route path="update-profile" element={<updateProfile />} /> */}


                  {/* admin */}

        <Route path="/super-admin" element={<SuperAdmin />}>
          <Route path="update-admin" element={<UpdateAdmin/>}/>
          <Route path="update-user" element={<UpdateProvider/>}/>
          <Route path="user-listing" element={<CommunityComp />} />
          <Route path="view-admin/:id" element={<ViewAdmin/>}/>
          {/* <Route path="homeowner-profile" element={<HomeadminprofileComp />} /> */}

          <Route path="admin-profile" element={<AdminprofileComp />} />
          <Route path="passwordChange" element={<PasswordChange/>} />
          <Route path="create-user" element={<CreatecommunityComp />} />
          <Route path="dashboard" element={<DashboardpageComp />} />
          {/* <Route path="dashboard" element={<DashboardpageComp />} /> */}
          <Route path="update-profile" element={<UpdateProfile />} />
          <Route path="inprogress" element={<InProgress />} />
          <Route
            path="super-admin-profile"
            element={<SuperadminprofileComp />}
          />
      
        </Route>

     
{/* 
        <Route path="/admin" element={<Admin />}>
      
          <Route path="create-community" element={<CreatecommunityComp />} />
          <Route path="dashboard" element={<DashboardpageComp />} />
          <Route path="update-profile" element={<UpdateProfile />} />
          <Route path="inprogress" element={<InProgress />} />
          <Route path="admin-profile" element={<AdminprofileComp />} />
          <Route path="chatboat"element={<Chatboat/>} />
          <Route path="passwordChange" element={<PasswordChange/>} />
          <Route path="view-admin/:id" element={<ViewAdmin/>}/>
          <Route path="update-provider" element={<UpdateProvider/>}/>
        </Route> */}

        {/* <Route path="/home-owner-admin" element={<HomeOwnerAdmin />}>
          
          <Route path="create-community" element={<CreatecommunityComp />} />
          <Route path="dashboard" element={<DashboardpageComp />} />
          <Route path="tab" element={<TabsComponent />} />
          <Route path="inprogress" element={<InProgress />} />
          <Route path="update-profile" element={<UpdateProfile />} />
        </Route> */}
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
